module.exports = __webpack_public_path__ + "img/sondrio.25e38d47.png";